import React from "react";
import { Select } from "./BaseSelect";
import { Form } from "antd";
import { useRequest } from "ahooks";
import { useHistory } from "react-router";
import { useShippingAreaStore } from "@/store/hooks";
import { observer } from "mobx-react-lite";

interface ShippingAreaSelectProps {}

const ShippingAreaSelect: React.FC<ShippingAreaSelectProps> = (props) => {
    const { loadList, loading, list } = useShippingAreaStore();

    const { runAsync } = useRequest(loadList, { manual: true });

    const history = useHistory();

    const handleChange = (value) => {
        if (value === "setting") history.push("/setting/shippingArea");
    };

    function handleSelectVisibleChange() {
        runAsync();
    }

    return (
        <Form.Item name="shippingAreaId" label={<span className="search-field-label">快递分区</span>}>
            <Select
                onChange={handleChange}
                onOpenChange={handleSelectVisibleChange}
                loading={loading}
                options={[
                    {
                        value: "",
                        key: "",
                        label: "",
                    },
                    ...(list?.map(({ id, name }) => {
                        return {
                            value: id,
                            key: id,
                            label: name,
                        };
                    }) ?? []),
                    {
                        value: "setting",
                        key: "setting",
                        label: "设置快递分区",
                    },
                ]}
            />
        </Form.Item>
    );
};

export default observer(ShippingAreaSelect);
